import { useState } from 'react';
import { getGivenName, getUserAlias } from 'src/components/authentication/AuthenticationUtils';
import { useAuthentication } from 'src/contexts/AuthenticationContext';
import styles from './UserInfo.module.css';

interface UserInfoProps {
  className?: string;
}

const BADGE_PHOTO_URL = 'https://badgephotos.corp.amazon.com';

const UserInfo: React.FC<UserInfoProps> = ({ className }) => {
  const { user, authSession } = useAuthentication();
  const userAlias = getUserAlias(user);
  const userName = getGivenName(authSession)?.trim() ?? 'Unknown User';
  const [imageError, setImageError] = useState(false);

  const initials = userName
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase();

  const colorIndex = userName.length % 4;

  return (
    <div className={`${styles.container} ${className || ''}`}>
      {imageError ? (
        <div
          className={`${styles.fallbackAvatar} ${styles[`color${colorIndex}`]}`}
          title={`Signed in as ${userName}`}
        >
          {initials}
        </div>
      ) : (
        <img
          alt={`${userName}'s avatar`}
          src={`${BADGE_PHOTO_URL}/?login=${userAlias}`}
          className={styles.avatarImage}
          title={`Signed in as ${userName}`}
          onError={() => setImageError(true)}
        />
      )}
    </div>
  );
};

export { UserInfo };
